//@flow
//TODO Get data from api.

// eslint-disable-next-line
export const subDiscount = 5;
